import { createTheme } from './createTheme';
import { baseTheme } from './baseTheme';
import { DARK_MODE, GRAY_SCALE, BORDER, BODY_BACKGROUND } from 'constants/ThemeConstant';
import { rgba, mixOnBackground, buildThemeCheckboxScopedStyles, getColoredHeaderTableTokens, buildThemeTableSorterScopedStyles } from './utils';

const LIGHT_PRIMARY = baseTheme.colorPrimary;
const LIGHT_BG = BODY_BACKGROUND;
const LIGHT_LAYOUT_BG = '#e5f2ff';
const LIGHT_TEXT = GRAY_SCALE.GRAY;
const LIGHT_BORDER = BORDER.BASE_COLOR;
const LIGHT_GROUP = '#66AFFF';
const LIGHT_MODULE_ICON = GRAY_SCALE.WHITE;
const LIGHT_TABLE_STRIPED_DARK = '#f5f5f5';
/** Màu opaque — tránh rgba trong suốt khiến nội dung scroll xuyên qua cột fixed */
const LIGHT_TABLE_ROW_HOVER = mixOnBackground(LIGHT_PRIMARY, 0.08, GRAY_SCALE.WHITE);
const LIGHT_TABLE_ROW_SELECTED = mixOnBackground(LIGHT_PRIMARY, 0.15, GRAY_SCALE.WHITE);
const LIGHT_TABLE_ROW_SELECTED_HOVER = mixOnBackground(LIGHT_PRIMARY, 0.24, GRAY_SCALE.WHITE);
const LIGHT_TABLE_ROW_DARK_HOVER = mixOnBackground(LIGHT_PRIMARY, 0.08, LIGHT_TABLE_STRIPED_DARK);
const LIGHT_TABLE_ROW_DARK_SELECTED = mixOnBackground(LIGHT_PRIMARY, 0.15, LIGHT_TABLE_STRIPED_DARK);
const LIGHT_TABLE_ROW_DARK_SELECTED_HOVER = mixOnBackground(LIGHT_PRIMARY, 0.24, LIGHT_TABLE_STRIPED_DARK);

/** Sidebar custom-menu — không dùng token Menu global */
export const lightCustomMenuStyles = `
.side-nav .custom-menu .ant-menu-item:not(.ant-menu-item-selected),
.side-nav .custom-menu .ant-menu-submenu:not(.ant-menu-submenu-selected):not(.ant-menu-submenu-open) > .ant-menu-submenu-title {
    color: ${LIGHT_TEXT} !important;
}
.side-nav .custom-menu .ant-menu-item:not(.ant-menu-item-selected) .anticon,
.side-nav .custom-menu .ant-menu-item:not(.ant-menu-item-selected) .ant-menu-item-icon,
.side-nav .custom-menu .ant-menu-submenu:not(.ant-menu-submenu-selected):not(.ant-menu-submenu-open) > .ant-menu-submenu-title .anticon,
.side-nav .custom-menu .ant-menu-submenu:not(.ant-menu-submenu-selected):not(.ant-menu-submenu-open) > .ant-menu-submenu-title .ant-menu-item-icon {
    color: ${LIGHT_PRIMARY} !important;
}
.side-nav .custom-menu .ant-menu-item-group-title,
.side-nav .custom-menu .ant-menu-item-group-title .nav-item_title {
    color: ${LIGHT_GROUP} !important;
}
.custom-menu-popup.ant-menu-dark:not(.custom-menu-popup-collapsed) .ant-menu-item,
.custom-menu-popup.ant-menu-dark:not(.custom-menu-popup-collapsed) .ant-menu-submenu-title {
    color: ${GRAY_SCALE.WHITE} !important;
}
.custom-menu-popup.ant-menu-dark:not(.custom-menu-popup-collapsed) .ant-menu-item .anticon,
.custom-menu-popup.ant-menu-dark:not(.custom-menu-popup-collapsed) .ant-menu-submenu-title .anticon {
    color: ${LIGHT_PRIMARY} !important;
}
`;

/** Steps điều hướng form (className="step-nav") */
export const lightStepNavStyles = `
.step-nav.ant-steps .ant-steps-item-title {
    color: ${LIGHT_TEXT} !important;
    font-size: 13px !important;
}
.step-nav.ant-steps .ant-steps-item-process .ant-steps-item-title,
.step-nav.ant-steps .ant-steps-item-finish .ant-steps-item-title {
    color: ${LIGHT_PRIMARY} !important;
    font-weight: 600 !important;
}
.step-nav.ant-steps .ant-steps-item-process .ant-steps-item-icon,
.step-nav.ant-steps .ant-steps-item-finish .ant-steps-item-icon {
    background-color: transparent !important;
    border-color: ${LIGHT_PRIMARY} !important;
}
.step-nav.ant-steps .ant-steps-item-process .ant-steps-item-icon .ant-steps-icon,
.step-nav.ant-steps .ant-steps-item-process .ant-steps-item-icon .anticon,
.step-nav.ant-steps .ant-steps-item-finish .ant-steps-item-icon .ant-steps-icon,
.step-nav.ant-steps .ant-steps-item-finish .ant-steps-item-icon .anticon {
    color: ${LIGHT_PRIMARY} !important;
}
.step-nav.ant-steps .ant-steps-item-wait .ant-steps-item-icon {
    background-color: transparent !important;
    border-color: ${LIGHT_BORDER} !important;
}
.step-nav.ant-steps .ant-steps-item-wait .ant-steps-item-icon .ant-steps-icon,
.step-nav.ant-steps .ant-steps-item-wait .ant-steps-item-icon .anticon {
    color: ${GRAY_SCALE.GRAY} !important;
}
/** Steps tiến trình (so-navigate-process-steps) — số trên nền primary */
body[data-theme='light'] .so-navigate-process-steps.ant-steps-vertical .ant-steps-item-process .ant-steps-item-icon .ant-steps-icon {
    color: ${GRAY_SCALE.WHITE} !important;
}
`;

export const lightScopedStyles = `
${lightCustomMenuStyles}
${lightStepNavStyles}
.ant-table-wrapper .ant-table-thead > tr > th {
    font-weight: 600;
    text-transform: uppercase;
}
${buildThemeTableSorterScopedStyles(LIGHT_PRIMARY)}
body[data-theme='light'] .ant-table-row.table-row-light:hover > .ant-table-cell:not(.nagaco-comment-cell),
body[data-theme='light'] .ant-table-row.table-row-dark:hover > .ant-table-cell:not(.nagaco-comment-cell),
body[data-theme='light'] .ant-table-row.table-row-light > .ant-table-cell-row-hover:not(.nagaco-comment-cell),
body[data-theme='light'] .ant-table-row.table-row-dark > .ant-table-cell-row-hover:not(.nagaco-comment-cell),
body[data-theme='light'] .table-row-light:hover td:not(.nagaco-comment-cell),
body[data-theme='light'] .table-row-dark:hover td:not(.nagaco-comment-cell) {
    background: ${LIGHT_TABLE_ROW_HOVER} !important;
}
body[data-theme='light'] .ant-table-row.table-row-dark:hover > .ant-table-cell:not(.nagaco-comment-cell),
body[data-theme='light'] .ant-table-row.table-row-dark > .ant-table-cell-row-hover:not(.nagaco-comment-cell),
body[data-theme='light'] .table-row-dark:hover td:not(.nagaco-comment-cell) {
    background: ${LIGHT_TABLE_ROW_DARK_HOVER} !important;
}
body[data-theme='light'] .ant-table-row.table-row-light.ant-table-row-selected > .ant-table-cell:not(.nagaco-comment-cell),
body[data-theme='light'] .ant-table-row.table-row-dark.ant-table-row-selected > .ant-table-cell:not(.nagaco-comment-cell),
body[data-theme='light'] .table-row-light.ant-table-row-selected > td:not(.nagaco-comment-cell),
body[data-theme='light'] .table-row-dark.ant-table-row-selected > td:not(.nagaco-comment-cell) {
    background: ${LIGHT_TABLE_ROW_SELECTED} !important;
}
body[data-theme='light'] .ant-table-row.table-row-dark.ant-table-row-selected > .ant-table-cell:not(.nagaco-comment-cell),
body[data-theme='light'] .table-row-dark.ant-table-row-selected > td:not(.nagaco-comment-cell) {
    background: ${LIGHT_TABLE_ROW_DARK_SELECTED} !important;
}
body[data-theme='light'] .ant-table-row.table-row-light.ant-table-row-selected:hover > .ant-table-cell:not(.nagaco-comment-cell),
body[data-theme='light'] .ant-table-row.table-row-dark.ant-table-row-selected:hover > .ant-table-cell:not(.nagaco-comment-cell),
body[data-theme='light'] .ant-table-row.table-row-light.ant-table-row-selected > .ant-table-cell-row-hover:not(.nagaco-comment-cell),
body[data-theme='light'] .ant-table-row.table-row-dark.ant-table-row-selected > .ant-table-cell-row-hover:not(.nagaco-comment-cell),
body[data-theme='light'] .table-row-light.ant-table-row-selected:hover td:not(.nagaco-comment-cell),
body[data-theme='light'] .table-row-dark.ant-table-row-selected:hover td:not(.nagaco-comment-cell) {
    background: ${LIGHT_TABLE_ROW_SELECTED_HOVER} !important;
}
body[data-theme='light'] .ant-table-row.table-row-dark.ant-table-row-selected:hover > .ant-table-cell:not(.nagaco-comment-cell),
body[data-theme='light'] .ant-table-row.table-row-dark.ant-table-row-selected > .ant-table-cell-row-hover:not(.nagaco-comment-cell),
body[data-theme='light'] .table-row-dark.ant-table-row-selected:hover td:not(.nagaco-comment-cell) {
    background: ${LIGHT_TABLE_ROW_DARK_SELECTED_HOVER} !important;
}
/* Cột fixed: nền opaque + z-index cao hơn để không bị chữ cột scroll đè lên */
body[data-theme='light'] .ant-table-wrapper .ant-table-tbody .ant-table-cell-fix-left,
body[data-theme='light'] .ant-table-wrapper .ant-table-tbody .ant-table-cell-fix-right {
    z-index: 3 !important;
}
body[data-theme='light'] .ant-table-wrapper .ant-table-thead .ant-table-cell-fix-left,
body[data-theme='light'] .ant-table-wrapper .ant-table-thead .ant-table-cell-fix-right {
    z-index: 4 !important;
}
${buildThemeCheckboxScopedStyles('light')}
body[data-theme='light'] {
    --nagaco-group-row-bg-0: ${LIGHT_GROUP};
    --nagaco-group-row-text-0: ${GRAY_SCALE.WHITE};
    --nagaco-group-row-border-0: ${LIGHT_GROUP};
    --nagaco-group-row-bg-1: ${LIGHT_GROUP};
    --nagaco-group-row-text-1: ${GRAY_SCALE.WHITE};
    --nagaco-group-row-border-1: ${LIGHT_GROUP};
    --nagaco-group-row-bg-2: ${LIGHT_GROUP};
    --nagaco-group-row-text-2: ${GRAY_SCALE.WHITE};
    --nagaco-group-row-border-2: ${LIGHT_GROUP};
    --nagaco-group-row-bg-3: ${LIGHT_GROUP};
    --nagaco-group-row-text-3: ${GRAY_SCALE.WHITE};
    --nagaco-group-row-border-3: ${LIGHT_GROUP};
    --nagaco-group-accent: ${GRAY_SCALE.WHITE};
    --nagaco-my-group-row-bg: ${LIGHT_GROUP};
    --nagaco-group-cell-border: ${LIGHT_GROUP};
    --nagaco-group-expand-bg: ${LIGHT_PRIMARY};
    --nagaco-group-expand-color: ${GRAY_SCALE.WHITE};
}
body[data-theme='light'] .row-has-children,
body[data-theme='light'] .row-has-children-depth-0,
body[data-theme='light'] .row-has-children-depth-1,
body[data-theme='light'] .row-has-children-depth-2,
body[data-theme='light'] .row-has-children-depth-3 {
    color: ${GRAY_SCALE.WHITE} !important;
}
body[data-theme='light'] .row-has-children > .ant-table-cell,
body[data-theme='light'] .row-has-children > .ant-table-cell-row-hover,
body[data-theme='light'] .row-has-children-depth-0 > .ant-table-cell,
body[data-theme='light'] .row-has-children-depth-1 > .ant-table-cell,
body[data-theme='light'] .row-has-children-depth-2 > .ant-table-cell,
body[data-theme='light'] .row-has-children-depth-3 > .ant-table-cell,
body[data-theme='light'] #tableMainSub .row-has-children > .ant-table-cell,
body[data-theme='light'] #tableMainSub .ant-table-row-level-0 > .ant-table-cell {
    background-color: ${LIGHT_GROUP} !important;
    border-color: ${LIGHT_GROUP} !important;
    color: ${GRAY_SCALE.WHITE} !important;
}
body[data-theme='light'] .row-has-children > .ant-table-cell p,
body[data-theme='light'] .row-has-children > .ant-table-cell div,
body[data-theme='light'] .row-has-children > .ant-table-cell span:not(.nagaco-group-expand-icon):not(.anticon),
body[data-theme='light'] #tableMainSub .row-has-children > .ant-table-cell p,
body[data-theme='light'] #tableMainSub .ant-table-row-level-0 > .ant-table-cell p,
body[data-theme='light'] #tableMainSub .row-has-children > .ant-table-cell div,
body[data-theme='light'] #tableMainSub .ant-table-row-level-0 > .ant-table-cell div {
    color: ${GRAY_SCALE.WHITE} !important;
}
`;

export const lightTheme = createTheme({
    primaryColor: LIGHT_PRIMARY,
    successColor: baseTheme.colorSuccess,
    warningColor: baseTheme.colorWarning,
    errorColor: baseTheme.colorError,

    bgColor: LIGHT_BG,
    textColor: LIGHT_TEXT,
    borderColor: LIGHT_BORDER,
    bodyBg: LIGHT_BG,
    colorBgLayout: LIGHT_BG,

    menuGroupTitleColor: LIGHT_GROUP,
    moduleMenuBg: LIGHT_PRIMARY,
    moduleMenuIconColor: LIGHT_MODULE_ICON,
    moduleMenuItemColor: GRAY_SCALE.WHITE,
    moduleMenuItemSelectedBg: GRAY_SCALE.WHITE,
    moduleMenuItemSelectedColor: LIGHT_PRIMARY,
    headerNavColor: GRAY_SCALE.WHITE,
    siderBg: GRAY_SCALE.WHITE,
    customMenuBg: GRAY_SCALE.WHITE,
    customMenuItemSelectedColor: LIGHT_PRIMARY,
    customMenuItemSelectedBg: rgba(LIGHT_PRIMARY, 0.12),
    customMenuItemSelectedIconColor: LIGHT_PRIMARY,
    customMenuItemSelectedBorderColor: LIGHT_PRIMARY,

    footerBg: GRAY_SCALE.WHITE,
    footerTextColor: GRAY_SCALE.GRAY,

    componentOverrides: {
        Layout: {
            bodyBg: LIGHT_LAYOUT_BG,
            headerBg: GRAY_SCALE.WHITE,
            siderBg: GRAY_SCALE.WHITE,
        },
        Menu: {
            darkItemBg: 'transparent',
            darkItemColor: GRAY_SCALE.WHITE,
            darkItemSelectedBg: DARK_MODE.ACTIVE_BG_COLOR,
            darkItemSelectedColor: GRAY_SCALE.WHITE,
            darkItemHoverBg: DARK_MODE.HOVER_BG_COLOR,
            darkItemHoverColor: GRAY_SCALE.GRAY_DARK,
            darkSubMenuItemBg: DARK_MODE.BG_COLOR,
            popupBg: DARK_MODE.BG_COLOR,
            activeBarWidth: 0,
            boxShadowSecondary: DARK_MODE.DROP_DOWN_SHADOW,
        },
        Breadcrumb: {
            itemColor: GRAY_SCALE.GRAY,
            lastItemColor: LIGHT_PRIMARY,
            linkColor: GRAY_SCALE.GRAY,
            linkHoverColor: LIGHT_PRIMARY,
            separatorColor: GRAY_SCALE.GRAY,
        },
        Card: {
            colorBgContainer: GRAY_SCALE.WHITE,
            colorTextHeading: LIGHT_PRIMARY,
            colorText: LIGHT_TEXT,
            colorBorderSecondary: LIGHT_BORDER,
            extraColor: LIGHT_TEXT,
            headerBg: GRAY_SCALE.WHITE,
            actionsBg: GRAY_SCALE.WHITE,
            borderRadiusLG: 22,
        },
        Table: {
            colorText: LIGHT_TEXT,
            colorTextHeading: GRAY_SCALE.WHITE,
            headerBg: LIGHT_PRIMARY,
            borderColor: '#F0F0F0',
            ...getColoredHeaderTableTokens(LIGHT_PRIMARY),
            rowHoverBg: LIGHT_TABLE_ROW_HOVER,
            rowSelectedBg: LIGHT_TABLE_ROW_SELECTED,
            rowSelectedHoverBg: LIGHT_TABLE_ROW_SELECTED_HOVER,
        },
        Steps: {
            colorPrimary: LIGHT_PRIMARY,
            colorText: LIGHT_TEXT,
            colorTextDescription: GRAY_SCALE.GRAY,
            colorTextLightSolid: GRAY_SCALE.WHITE,
        },
        Input: {
            colorBgContainer: GRAY_SCALE.WHITE,
            colorBorder: LIGHT_BORDER,
            activeBorderColor: LIGHT_PRIMARY,
            hoverBorderColor: LIGHT_PRIMARY,
        },
        DatePicker: {
            colorBgContainer: GRAY_SCALE.WHITE,
            colorBorder: LIGHT_BORDER,
            activeBorderColor: LIGHT_PRIMARY,
            hoverBorderColor: LIGHT_PRIMARY,
        },

        Select: {
            colorBgContainer: GRAY_SCALE.WHITE,
            selectorBg: GRAY_SCALE.WHITE,
            colorBgElevated: GRAY_SCALE.WHITE,
            optionSelectedBg: rgba(LIGHT_PRIMARY, 0.1),
            optionActiveBg: rgba(LIGHT_PRIMARY, 0.06),
            colorBorder: LIGHT_BORDER,
            activeBorderColor: LIGHT_PRIMARY,
            hoverBorderColor: LIGHT_PRIMARY,
        },
        Button: {
            defaultBg: GRAY_SCALE.WHITE,
            defaultHoverBg: GRAY_SCALE.WHITE,
            defaultActiveBg: GRAY_SCALE.WHITE,
            defaultBorderColor: LIGHT_BORDER,
            defaultHoverBorderColor: LIGHT_PRIMARY,
            defaultActiveBorderColor: LIGHT_PRIMARY,
        },
        Pagination: {
            colorBgContainer: GRAY_SCALE.WHITE,
            colorBorder: LIGHT_BORDER,
            activeBorderColor: LIGHT_PRIMARY,
            hoverBorderColor: LIGHT_PRIMARY,
        },
        Segmented: {
            itemSelectedBg: LIGHT_PRIMARY,
            itemSelectedColor: GRAY_SCALE.WHITE,
        }
    },
});
